import AnnouncementDetails from './AnnouncementDetails';
export default AnnouncementDetails;
